import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { FillScreen } from '@/components/Layout';

import DataTableCard from './-components/DataTableCard';
import FilterBar from './-components/FilterBar';
import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/settings/permission-and-roles/_list/category-permissions/',
)({
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <FilterBar search={search} navigate={navigate} />
      <DataTableCard search={search} navigate={navigate} />
    </FillScreen>
  );
}
